document.addEventListener('DOMContentLoaded', function () {
  var items = Array.from(document.querySelectorAll('.faq__item'));

  items.forEach(function (detail) {
    var summary = detail.querySelector('summary');
    var content = detail.querySelector('.faq__a');
    var inner = detail.querySelector('.faq__aInner');

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      if (detail.open) {
        closeItem(detail, content);
      } else {
        items.forEach(function (other) {
          if (other !== detail && other.open) {
            closeItem(other, other.querySelector('.faq__a'));
          }
        });
        openItem(detail, content, inner);
      }
    });
  });

  function openItem(detail, content, inner) {
    detail.setAttribute('open', '');
    content.style.height = '0px';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        content.style.height = inner.offsetHeight + 'px';
      });
    });
    content.addEventListener('transitionend', function handler() {
      content.style.height = 'auto';
      content.removeEventListener('transitionend', handler);
    });
  }

  function closeItem(detail, content) {
    content.style.height = content.offsetHeight + 'px';
    requestAnimationFrame(function () {
      content.style.height = '0px';
    });
    content.addEventListener('transitionend', function handler() {
      detail.removeAttribute('open');
      content.style.height = '';
      content.removeEventListener('transitionend', handler);
    });
  }
});
